<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-times-circle-o fa-lg icon-button"
                title="Descomprometer"
                @click.stop="confirmarDescomprometer()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        comprometimento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDescomprometer() {
            this.$swal({
                title: 'Descomprometimento',
                html: `Confirma a realização do descomprometimento do id ${this.comprometimento.idComprometimento} do 
                contrato ${this.contrato.vcCodigoEstruturado} no RM?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.descomprometer()
                }
            })
        },

        descomprometer() {
            this.$emit('descomprometer', this.comprometimento.idComprometimento)
        }
    }
}
</script>
